import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { type PayloadAction } from "@reduxjs/toolkit";
import { photoUploadActions } from "./slice";
import {
  photoUploadSave,
  validateToken
} from "../../services/photoUpload/photoUpload.api";
import { withLoader } from "../loader/saga";
import { PhotoUploadPayload, ValidateTokenPayload } from "../../types/photoUpload";

// Worker Saga for POST
export function* validateTokenSaga(
  action: PayloadAction<ValidateTokenPayload>
): SagaIterator {
  try {
    const response = yield* withLoader(function* () {
      return yield call(validateToken, action.payload);
    });
    yield put(photoUploadActions.submitValidateTokenSuccess(response));
  } catch (error: any) {
    yield put(
      photoUploadActions.submitValidateTokenFailure(
        "Something went wrong.Please try again."
      )
    );
  }
}

function* validateTokenWatcherSaga() {
  yield takeLatest(
    photoUploadActions.validateToken.type,
    validateTokenSaga
  );
}


// Worker Saga for POST
export function* photoUploadSaveSaga(
  action: PayloadAction<PhotoUploadPayload>
): SagaIterator {
  try {
    const response = yield* withLoader(function* () {
      return yield call(photoUploadSave, action.payload);
    });
    yield put(photoUploadActions.submitPhotoUploadSuccess(response));
  } catch (error: any) {
    yield put(
      photoUploadActions.submitPhotoUploadFailure(
        "Something went wrong.Please try again."
      )
    );
  }
}

function* photoUploadWatcherSaga() {
  yield takeLatest(
    photoUploadActions.submitPhotoUploadStart.type,
    photoUploadSaveSaga
  );
}

export {
  validateTokenWatcherSaga, photoUploadWatcherSaga
};
